import { delay } from 'redux-saga'
import {
  select,
  fork,
  put,
  all,
  call,
  take,
  takeLatest,
  takeEvery,
  cancelled,
} from 'redux-saga/effects'
import T from 'i18n-react'
import {
  post,
  getRequest
} from 'helpers/RequestUtil'

import {
  POST_CANCEL_PROJECT,
} from './constants'

import {
  startCancelProject,
  postCancelProjectError,
  postCancelProjectStart,
  postCancelProjectSuccess,
} from './actions'

import {
  error,
  success
} from 'containers/App/Notification/actions'

import {
  projectIdSelector,
  workflowIdSelector,
} from './selectors'



function* postCancelProject(workflowId, projectId) {
  try {
    yield put(startCancelProject())
    yield put(postCancelProjectStart())
    yield call(post, 'cancels', { workflowId }, '/api/fulcrum/workflow/cancels')
    yield put(postCancelProjectSuccess())
    yield put(success(T.translate(
      'pages.project.view.notification.post_cancel_success',
      {id: projectId}
    )))
  } catch (e) {
    /* handle error */
    yield put(postCancelProjectError(e))
    yield put(error(T.translate(
      'pages.project.view.notification.post_cancel_error',
      {id: projectId}
    )))
  }
}

function* handleCancelProject(action) {
  const projectId = yield select(projectIdSelector)
  const workflowId = yield select(workflowIdSelector)
  yield call(postCancelProject, workflowId, projectId)
}

function* watchPostCancelProject() {
  yield takeLatest(POST_CANCEL_PROJECT, handleCancelProject)
}



function* loadSagas() {
  yield all([
    fork(watchPostCancelProject)
  ])
}

export default loadSagas
